import { render, staticRenderFns } from "./DashboardMeasures.vue?vue&type=template&id=1bfc3bdd"
import script from "./DashboardMeasures.vue?vue&type=script&lang=ts"
export * from "./DashboardMeasures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports